<ng-container *ngIf="activeLanguage$ | async as activeLanguage">
  <ng-container *ngIf="activeLanguage === 'en'">
    <div class="container">
      <h3 class="annouce-title">ANNOUNCEMENTS</h3>
      <p class="annouce-section-1">Bendix now <a [attr.href]="documentUrlsMap['BW8291'] |async"
          (Click)="loadDocument('BW8291')" target='_blank' rel='noopener noreferrer'><b>offers a Core Program in
            Mexico</b> </a> You can submit your core returns, check your
        core reports to verify eligibility, and search for
        previously submitted core returns.
      </p>
      <p class="annouce-section-2">Please take a minute to familiarize yourself with the core returns page and
        review some of the important documents</p>
      <p class="annouce-section-3"><a [attr.href]="documentUrlsMap['BW1020ALL'] |async"
          (Click)="loadDocument('BW1020ALL')" target='_blank' rel='noopener noreferrer'>The Core Handbook</a></p>
      <p class="annouce-section-3"><a [attr.href]="documentUrlsMap['Y639946'] |async" (Click)="loadDocument('Y639946')"
          target='_blank' rel='noopener noreferrer'>Bendix Core Return Packaging</a></p>
      <p class="annouce-section-3"><a [attr.href]="documentUrlsMap['Y458937'] |async" (Click)="loadDocument('Y458937')"
          target='_blank' rel='noopener noreferrer'>How to View Bendix Core Reports</a></p>
    </div>
  </ng-container>
  <ng-container *ngIf="activeLanguage === 'es_MX'">
    <div class="container">
      <h3 class="annouce-title">ANUNCIOS</h3>
      <p class="annouce-section-1">
        Bendix ahora
        <a [attr.href]="documentUrlsMap['BW8291'] |async" (mouseenter)="loadDocument('BW8291')" target="_blank"
          rel="noopener noreferrer">
          <b>ofrece un Programa de Núcleos en México</b>
        </a>.
        Puede enviar sus devoluciones de núcleos, consultar sus reportes de núcleos para verificar su elegibilidad y
        buscar devoluciones de núcleos enviadas anteriormente.
      </p>
      <p class="annouce-section-2">
        Por favor, tómese un momento para familiarizarse con la página de devoluciones de núcleos y revisar algunos de
        los documentos importantes.
      </p>
      <p class="annouce-section-3">
        <a [attr.href]="documentUrlsMap['BW1020ALL'] |async" (mouseenter)="loadDocument('BW1020ALL')" target="_blank"
          rel="noopener noreferrer">
          El Manual Básico
        </a>
      </p>
      <p class="annouce-section-3">
        <a [attr.href]="documentUrlsMap['Y639946'] |async" (mouseenter)="loadDocument('Y639946')" target="_blank"
          rel="noopener noreferrer">
          Material de embalaje para la devolución de núcleos de Bendix
        </a>
      </p>
      <p class="annouce-section-3">
        <a [attr.href]="documentUrlsMap['Y458937'] |async" (mouseenter)="loadDocument('Y458937')" target="_blank"
          rel="noopener noreferrer">
          Cómo consultar los informes de Bendix Core
        </a>
      </p>
    </div>
  </ng-container>
</ng-container>